import React, { useContext } from "react";
import { Grid, Grow } from "@material-ui/core";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import { Documentos } from "../styles/Emissao";
import { EmissaoContext } from "../contexts/EmissaoContext";

const TabNFEComplementada = () => {
  const { visualizationOnly, complementedAccessKey, setComplementedAccessKey } =
    useContext(EmissaoContext);

  return (
    <Documentos>
      <Grow in={true}>
        <Grid container spacing={2}>
          <Grid item lg={12} sm={12}>
            <TextFieldErp
              value={complementedAccessKey}
              onChange={({ target: { value } }) => {
                setComplementedAccessKey((value || "").replace(/[^0-9]/g, ""));
              }}
              label="Chave de Acesso"
              size="small"
              maxLength={44}
              disabled={visualizationOnly}
            />
          </Grid>
        </Grid>
      </Grow>
    </Documentos>
  );
};

export default TabNFEComplementada;
